import type { SelectHTMLAttributes } from "react";

const Caret = () => (
  <svg className="select-caret" width="15" height="15" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <span className="select-wrap">
      <select className={["control", "select", className].filter(Boolean).join(" ")} {...props}>
        {children}
      </select>
      <Caret />
    </span>
  );
}
